/**
 * Stores build information about <b>this specific version of the `ruffle-core` library</b>.
 *
 * It does not represent the version of Ruffle that may be in use by the page (for example, if a browser extension overrides it).
 *
 * @privateRemarks
 * This is generated at build time via `set_version.ts`.
 */
export const buildInfo = {
    versionNumber: "0.4.0-nightly.2026.7.7",
    versionName: "0.4.0-nightly.2026.7.7",
    versionChannel: "nightly",
    buildDate: "2026-07-07T00:34:30.387Z",
    commitHash: "c71b28ce87bf10583644b1428fa3e1456ae09b35",
};
